import { Directive, TemplateRef, Input, HostListener, ElementRef,
  ViewContainerRef, Renderer2, ViewRef, Output, EventEmitter, SimpleChanges, OnChanges, EmbeddedViewRef, AfterViewChecked, AfterContentInit } from '@angular/core';
import { TooltipEvent } from './types';

@Directive({
  selector: '[qmTooltip]',
  exportAs: 'qmTooltip'
})
export class TooltipDirective implements OnChanges, AfterViewChecked {

  @Output() tipClick = new EventEmitter<TooltipEvent>();

  private rootEl: HTMLDivElement;
  private backdropEl: HTMLDivElement;
  private tooltipElemWidth: number;
  private tooltipView: EmbeddedViewRef<HTMLDivElement>;

  constructor(
    private elementRef: ElementRef,
    private viewContainerRef: ViewContainerRef,
    private renderer: Renderer2
  ) { }

  @Input()
  qmTooltip: TemplateRef<HTMLDivElement>;

  @Input()
  clientRect: DOMRect;

  @HostListener('click', ['$event'])
  hostClicked($event: MouseEvent) {
    this.tipClick.next({event: $event, isOpen: false});
  }

  ngOnChanges(changes: SimpleChanges) {
    if (!changes.clientRect?.currentValue) {
      return;
    }
    this.tooltipElemWidth = changes.clientRect.currentValue.width;
    if (this.tooltipElemWidth && this.rootEl) {
      let nodeLeft = this.rootEl.getBoundingClientRect().left;
      if ( nodeLeft + this.tooltipElemWidth > window.innerWidth) {
        nodeLeft = window.innerWidth - this.tooltipElemWidth;
      }
      this.rootEl.style.left = nodeLeft + 'px';
    }
  }
  ngAfterViewChecked() {
    if (this.tooltipElemWidth != null && this.rootEl) {
      let nodeLeft = this.rootEl.getBoundingClientRect().left;
      if ( nodeLeft + this.tooltipElemWidth > window.innerWidth) {
        nodeLeft = window.innerWidth - this.tooltipElemWidth;
      }
      this.rootEl.style.left = nodeLeft + 'px';
    }
  }

  public open = (obj?: { event: MouseEvent, [key: string]: any }) => {
    this.tooltipView = this.viewContainerRef.createEmbeddedView<HTMLDivElement>(this.qmTooltip);

    // The input values for the template
    for (const key in obj) {
      if (typeof key === 'string' ) {
        this.tooltipView.context[key] = obj[key];
      }
    }
    this.tooltipView.rootNodes.forEach((node: HTMLElement) => {
      /**
       * Template inside tooltip
       */
      this.rootEl = this.renderer.createElement('div') as HTMLDivElement;
      this.rootEl.appendChild(node);

      // Show the tooltip below the child element
      this.rootEl.style.position = 'fixed';
      this.rootEl.style.top = obj.event?.clientY + 'px';
      this.rootEl.style.left = obj.event?.clientX + 'px';
      this.rootEl.style.zIndex = '100';

      if (this.tooltipElemWidth != null) {
        let nodeLeft = this.rootEl.getBoundingClientRect().left;
        if ( nodeLeft + this.tooltipElemWidth > window.innerWidth) {
          nodeLeft = window.innerWidth - this.tooltipElemWidth;
          this.rootEl.style.left = nodeLeft + 'px';
        }
      }

      // Calculate height and width according to screen
      node.style.maxHeight = (window.innerHeight - obj.event?.clientY - 10) + 'px';
      node.style.overflowY = 'auto';
      this.renderer.appendChild(document.body, this.rootEl);

      /**
       * Backdrop behind tooltip for closing it
       */
      this.backdropEl = this.renderer.createElement('div') as HTMLDivElement;
      this.backdropEl.style.position = 'fixed';
      this.backdropEl.style.top = '0px';
      this.backdropEl.style.left = '0px';
      this.backdropEl.style.height = '100vh';
      this.backdropEl.style.width = '100vw';
      this.backdropEl.style.zIndex = '99';
      this.backdropEl.addEventListener('click', this.close);

      this.renderer.appendChild(document.body, this.backdropEl);
    });
  }

  public close = (e?: MouseEvent) => {
    if (e) {
      e.preventDefault();
    }
    if (this.tooltipView) {
      this.tooltipView.destroy();
      this.tooltipView = null;
    }
    if (this.rootEl) {
      this.rootEl.remove();
      this.rootEl = null;
    }
    if (this.backdropEl) {
      this.backdropEl.remove();
      this.backdropEl = null;
    }
    this.tooltipElemWidth = null;
    this.tipClick.next({event: e, isOpen: true});
  }

}
